import images from './images.json'

// Canvas 2d context.
var ctx = null

// Set the canvas 2d context.
function setContext(context) {
    ctx = context
}

// Returns the canvas 2d context.
function getContext() {
    return ctx
}

// Return loaded image object from the list.
function getImage(name) {
    let img = images.filter(f => f.name === name)
    return img.length > 0 ? img[0].image : null
}

// Returns the full list of image objects.
function getImages() {
    return images
}

/**
 * Draws an image at x,y coordinates on the canas.
 * @param {string} name 
 * @param {float} x 
 * @param {float} y 
 * @param {object} srcRect 
 * @param {boolean} flipped 
 */
function drawImage(name, x, y, srcRect, flipped) {
    drawImageCtx(getContext(), name, x, y, srcRect, flipped)
}

/**
 * Raw image drawing function (use drawImage unless you want to draw to another 2d context).
 * @param {object} context Canvas 2d context.
 * @param {string} name 
 * @param {float} x 
 * @param {float} y 
 * @param {object} srcRect 
 * @param {boolean} flipped 
 */
function drawImageCtx(context, name, x, y, srcRect, flipped) {
    let img = images.filter(f => f.name === name)
    if (img.length > 0) {
        try {
            if (srcRect) {
                if (flipped) {
                    context.save()
                    context.scale(-1, 1)
                    context.drawImage(img[0].image, srcRect.x, srcRect.y, srcRect.w, srcRect.h, -x - srcRect.w, y, srcRect.w, srcRect.h)    
                    context.restore()
                } else {
                    context.drawImage(img[0].image, srcRect.x, srcRect.y, srcRect.w, srcRect.h, x, y, srcRect.w, srcRect.h)    
                }
            } else {
                if (flipped) {
                    context.save()
                    context.scale(-1, 1)
                    context.drawImage(img[0].image, x - srcRect.w, y, srcRect.w, srcRect.h)    
                    context.restore()
                } else {
                    context.drawImage(img[0].image, x, y)
                }
            }
        } catch {}
    }
}

/**
 * Load Image
 * @param {string} filename 
 * @returns 
 */
function loadImage(filename) {
    return new Promise((resolve, reject) => {
        let img = new Image()
        img.onload = (e) => {
            resolve(img)
        }
        img.onerror = (e) => {
            console.error(`Failed to load file ${filename}:`, e)
            reject(null)
        }
        let image = images.filter(f => f.filename === filename)
        if (image.length > 0) {
            img.src = filename
        } else {
            console.error(`Image definition matching filename ${filename} not found.`)
            reject(null)
        }
    })
}

/**
 * Load all images in the images list.
 * @returns 
 */
function loadAllImages() {
    let promises = []
    for (let i in images) {
        let image = images[i]
        promises.push(new Promise((resolve, reject) => loadImage(image.filename).then(r => {
            image.image = r
            resolve(r)
        }).catch(e => console.error('Failed to load', image.filename, e))))
    }
    return Promise.allSettled(promises)
}

export { loadAllImages, loadImage, drawImage, getImage, getImages, setContext, drawImageCtx, getContext }
